import React from "react";
import LogoIconContainer, {
  LogoIconContainerProps
} from "@/components/ui/logo-icon-container";
import { EntityType } from "@/components/ui/entity-type";
import { getEntityIcon } from "@/components/ui/entity-icon";

export interface EntityLogoIconContainerProps
  extends Omit<LogoIconContainerProps, "icon"> {
  entityType: EntityType;
}

const EntityLogoIconContainer: React.FC<EntityLogoIconContainerProps> = ({
  entityType,
  index = -1,
  className,
  iconSize = "5",
  ...props
}) => {
  const icon = getEntityIcon(entityType);

  return (
    <LogoIconContainer
      icon={icon}
      index={index}
      className={`size-8 flex-shrink-0 ${className || ""}`}
      iconSize={iconSize}
      {...props}
    />
  );
};

export default EntityLogoIconContainer;
